export default __webpack_public_path__ + "static/media/iGaming-bot.f129fa23.svg";